export const downloadFileFromPayload = (payload, filename) => {
  const blob = new Blob([payload])
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = filename
  link.click()
}

export const getFileDimensions = file =>
  new Promise((resolve, reject) => {
    const fr = new FileReader()

    fr.onload = () => {
      // file is loaded
      const img = new Image()
      img.onload = () => {
        const { width, height } = img
        resolve({ width, height })
      }

      img.src = fr.result as string
    }

    fr.onerror = reject

    fr.readAsDataURL(file)
  })

export const getHtml5Dimensions = ({ name }) => {
  const matches = name.match(/\d+x\d+/)
  if (!matches) return undefined
  const [width, height] = matches[0].split('x')
  return { width, height }
}
